import { createUrlParameters } from '@comeon/utility';
import { postJson } from '~/core/ajax-json.js';
import { requestApi } from '~/services/api.js';

const API_BASE_PATH = process.env.API_BASE_PATH || '';
const PAYMENT_SERVICE_HOST = process.env.PAYMENT_SERVICE_HOST || '';

function getWithdrawVerification() {
	return requestApi(`${PAYMENT_SERVICE_HOST || API_BASE_PATH}/PaymentFormDataService/getWithdrawVerification`);
}

function getWithdrawPaymentMethods(isMobileDevice = true) {
	const path = '/PaymentFormDataService/getWithdrawPaymentMethods';
	const queryString = isMobileDevice ? '?isMobileDevice=true' : '';

	return requestApi(`${PAYMENT_SERVICE_HOST || API_BASE_PATH}${path}${queryString}`);
}

/**
 * @param {{formTemplateMobileUrl: string, formTemplateUrlParams: string}} param
 */
function requestFormTemplateDetail({ formTemplateMobileUrl, formTemplateUrlParams }) {
	if (!formTemplateMobileUrl) {
		throw new Error('Fatal error occured');
	}

	const payload = `isMobile=true${formTemplateUrlParams}`;

	return requestApi(`${PAYMENT_SERVICE_HOST || API_BASE_PATH}${formTemplateMobileUrl}`, payload, 'POST', true);
}

function fetchFeesAndLimits(data) {
	const url = `${API_BASE_PATH}/PaymentFormDataService/geWithdrawFeesAndLimits/forMobile?t=${Date.now()}`;
	return requestApi(url, createUrlParameters(data), 'POST', true);
}

function saveNewCreditCard(data) {
	const url = `${API_BASE_PATH}/CreditCardIntegration/playerCard/addPlayerCard`;
	return postJson(url, data);
}

function postWithdrawForm(url, data) {
	return postJson(API_BASE_PATH + url, data);
}

function fetchBalance() {
	const url = `${API_BASE_PATH}/PaymentFormDataService/getWithdrawBalance?t=${Date.now()}`;
	return requestApi(url);
}

function isKycNeeded(paymentMethodData) {
	const kycCheckParameters = paymentMethodData;
	kycCheckParameters.isMobileDevice = true;
	return requestApi(
		`${API_BASE_PATH}/KycService/public/getValidateKYCStatus?${createUrlParameters(kycCheckParameters)}`
	);
}

const seonVerification = payload => {
	return requestApi(`${API_BASE_PATH}/seon-service/public/payment/device-session/save`, payload, 'POST');
};

export {
	getWithdrawVerification,
	getWithdrawPaymentMethods,
	fetchFeesAndLimits,
	fetchBalance,
	saveNewCreditCard,
	postWithdrawForm,
	requestFormTemplateDetail,
	isKycNeeded,
	seonVerification
};
